import _objectWithoutProperties from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js";
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
import { createContext, useRef, useContext, useState, useReducer, useEffect } from 'react';
import eq from 'react-fast-compare';
import { jsx } from 'react/jsx-runtime';
var ClientContext = /*#__PURE__*/createContext(void 0);
function useOpts(arg) {
  var argRef = useRef(arg);
  if (!eq(arg, argRef.current)) {
    argRef.current = arg;
  }
  return argRef.current;
}
var EMPTY_CONFIG = {};
var isSSR = typeof window === "undefined";
function getNewClient(_x) {
  return _getNewClient.apply(this, arguments);
}
function _getNewClient() {
  _getNewClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(config) {
    var StreamrClient;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!(config === EMPTY_CONFIG || isSSR)) {
            _context10.next = 2;
            break;
          }
          return _context10.abrupt("return", void 0);
        case 2:
          _context10.next = 4;
          return import('streamr-client');
        case 4:
          StreamrClient = _context10.sent.default;
          return _context10.abrupt("return", new StreamrClient(config));
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getNewClient.apply(this, arguments);
}
function useClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_CONFIG;
  var parentClient = useContext(ClientContext);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    client = _useState2[0],
    setClient = _useState2[1];
  var conf = useOpts(config);
  var _useReducer = useReducer(function (x) {
      return x + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    cacheKey = _useReducer2[0],
    invalidate = _useReducer2[1];
  useEffect(function () {
    var mounted = true;
    if (conf === EMPTY_CONFIG) {
      return;
    }
    function fn() {
      return _fn.apply(this, arguments);
    }
    function _fn() {
      _fn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newClient;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getNewClient(conf);
            case 2:
              newClient = _context.sent;
              if (newClient) {
                newClient.destroySignal.onDestroy.listen(function () {
                  invalidate();
                });
              }
              if (mounted) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              setClient(newClient);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fn.apply(this, arguments);
    }
    fn();
    return function () {
      mounted = false;
    };
  }, [conf, cacheKey]);
  useEffect(function () {
    return function () {
      client === null || client === void 0 ? void 0 : client.destroy();
    };
  }, [client]);
  return config === EMPTY_CONFIG ? parentClient : client;
}
function resend(stream, options, streamrClient) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$ignoreUndecodedM = _ref.ignoreUndecodedMessages,
    ignoreUndecodedMessages = _ref$ignoreUndecodedM === void 0 ? false : _ref$ignoreUndecodedM,
    onMessageError = _ref.onMessageError,
    onError = _ref.onError;
  var cancelled = false;
  var rs = new ReadableStream({
    start: function start(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var queue, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return streamrClient.resend(stream, options);
            case 3:
              queue = _context2.sent;
              if (!cancelled) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              queue.pipeline.onMessage.listen(function (streamMessage) {
                controller.enqueue(streamMessage);
              });
              queue.onError.listen(function (e) {
                if (typeof onMessageError === "function") {
                  onMessageError(e);
                }
                var msg = e.streamMessage;
                if (!msg) {
                  return;
                }
                if (!ignoreUndecodedMessages) {
                  controller.enqueue(msg);
                }
              });
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.prev = 10;
              _iterator = _asyncIterator(queue);
            case 12:
              _context2.next = 14;
              return _iterator.next();
            case 14:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                _context2.next = 19;
                break;
              }
              _ = _step.value;
            case 16:
              _iteratorAbruptCompletion = false;
              _context2.next = 12;
              break;
            case 19:
              _context2.next = 25;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context2.t0;
            case 25:
              _context2.prev = 25;
              _context2.prev = 26;
              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context2.next = 30;
                break;
              }
              _context2.next = 30;
              return _iterator.return();
            case 30:
              _context2.prev = 30;
              if (!_didIteratorError) {
                _context2.next = 33;
                break;
              }
              throw _iteratorError;
            case 33:
              return _context2.finish(30);
            case 34:
              return _context2.finish(25);
            case 35:
              _context2.next = 40;
              break;
            case 37:
              _context2.prev = 37;
              _context2.t1 = _context2["catch"](0);
              onError === null || onError === void 0 ? void 0 : onError(_context2.t1);
            case 40:
              _context2.prev = 40;
              controller.close();
              return _context2.finish(40);
            case 43:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 37, 40, 43], [10, 21, 25, 35], [26,, 30, 34]]);
      }))();
    },
    cancel: function cancel() {
      cancelled = true;
    }
  });
  var reader = rs.getReader();
  return {
    next: function next() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", reader.read());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    abort: function abort() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return reader.cancel();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  };
}
function useResend(streamDef) {
  var resendOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    last: 1
  };
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    cacheKey = _ref2.cacheKey,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$ignoreUndecoded = _ref2.ignoreUndecodedMessages,
    ignoreUndecodedMessages = _ref2$ignoreUndecoded === void 0 ? false : _ref2$ignoreUndecoded,
    onAfterFinish = _ref2.onAfterFinish,
    onBeforeStart = _ref2.onBeforeStart,
    onError = _ref2.onError,
    onMessage = _ref2.onMessage,
    onMessageError = _ref2.onMessageError;
  var stream = useOpts(streamDef);
  var opts = useOpts(resendOptions);
  var client = useClient();
  var onMessageRef = useRef(onMessage);
  useEffect(function () {
    onMessageRef.current = onMessage;
  }, [onMessage]);
  var onErrorRef = useRef(onError);
  useEffect(function () {
    onErrorRef.current = onError;
  }, [onError]);
  var onMessageErrorRef = useRef(onMessageError);
  useEffect(function () {
    onMessageErrorRef.current = onMessageError;
  }, [onMessageError]);
  var onBeforeStartRef = useRef(onBeforeStart);
  useEffect(function () {
    onBeforeStartRef.current = onBeforeStart;
  }, [onBeforeStart]);
  var onAfterFinishRef = useRef(onAfterFinish);
  useEffect(function () {
    onAfterFinishRef.current = onAfterFinish;
  }, [onAfterFinish]);
  useEffect(function () {
    var _onBeforeStartRef$cur;
    if (!client || disabled) {
      return function () {};
    }
    (_onBeforeStartRef$cur = onBeforeStartRef.current) === null || _onBeforeStartRef$cur === void 0 ? void 0 : _onBeforeStartRef$cur.call(onBeforeStartRef);
    var queue = resend(stream, opts, client, {
      onError: function onError(e) {
        var _onErrorRef$current;
        (_onErrorRef$current = onErrorRef.current) === null || _onErrorRef$current === void 0 ? void 0 : _onErrorRef$current.call(onErrorRef, e);
      },
      onMessageError: function onMessageError(e) {
        var _onMessageErrorRef$cu;
        (_onMessageErrorRef$cu = onMessageErrorRef.current) === null || _onMessageErrorRef$cu === void 0 ? void 0 : _onMessageErrorRef$cu.call(onMessageErrorRef, e);
      },
      ignoreUndecodedMessages: ignoreUndecodedMessages
    });
    function fn(_x2) {
      return _fn2.apply(this, arguments);
    }
    function _fn2() {
      _fn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(q) {
        var _onAfterFinishRef$cur;
        var _yield$q$next, value, done, _onMessageRef$current;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!true) {
                _context5.next = 11;
                break;
              }
              _context5.next = 3;
              return q.next();
            case 3:
              _yield$q$next = _context5.sent;
              value = _yield$q$next.value;
              done = _yield$q$next.done;
              if (value) {
                (_onMessageRef$current = onMessageRef.current) === null || _onMessageRef$current === void 0 ? void 0 : _onMessageRef$current.call(onMessageRef, value);
              }
              if (!done) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("break", 11);
            case 9:
              _context5.next = 0;
              break;
            case 11:
              (_onAfterFinishRef$cur = onAfterFinishRef.current) === null || _onAfterFinishRef$cur === void 0 ? void 0 : _onAfterFinishRef$cur.call(onAfterFinishRef);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _fn2.apply(this, arguments);
    }
    fn(queue);
    return function () {
      queue === null || queue === void 0 ? void 0 : queue.abort();
    };
  }, [stream, opts, client, disabled, ignoreUndecodedMessages, cacheKey]);
}
function subscribe(stream, streamrClient) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$ignoreUndecoded = _ref3.ignoreUndecodedMessages,
    ignoreUndecodedMessages = _ref3$ignoreUndecoded === void 0 ? false : _ref3$ignoreUndecoded,
    onError = _ref3.onError,
    onMessageError = _ref3.onMessageError,
    resendOptions = _ref3.resendOptions;
  var sub;
  var cancelled = false;
  function unsub() {
    if (sub) {
      streamrClient.unsubscribe(sub);
      sub = void 0;
    }
  }
  var rs = new ReadableStream({
    start: function start(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var options;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              options = typeof stream === "string" ? {
                id: stream
              } : stream;
              _context6.next = 4;
              return streamrClient.subscribe(_objectSpread(_objectSpread({}, options), {}, {
                resend: resendOptions
              }),
              // Does not fly without the "legacy" on-message callback.
              function () {});
            case 4:
              sub = _context6.sent;
              if (!cancelled) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return", void unsub());
            case 7:
              sub.pipeline.onMessage.listen(function (streamMessage) {
                controller.enqueue(streamMessage);
              });
              sub.on("error", function (e) {
                onMessageError === null || onMessageError === void 0 ? void 0 : onMessageError(e);
                var raw = e.streamMessage;
                if (!raw) {
                  return;
                }
                if (!ignoreUndecodedMessages) {
                  controller.enqueue(raw);
                }
              });
              _context6.next = 15;
              break;
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](0);
              onError === null || onError === void 0 ? void 0 : onError(_context6.t0);
              controller.close();
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 11]]);
      }))();
    },
    cancel: function cancel() {
      unsub();
      cancelled = true;
    }
  });
  var reader = rs.getReader();
  return {
    next: function next() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", reader.read());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    abort: function abort() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return reader.cancel();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  };
}
function useSubscribe(streamDef) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    cacheKey = _ref4.cacheKey,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    _ref4$ignoreUndecoded = _ref4.ignoreUndecodedMessages,
    ignoreUndecodedMessages = _ref4$ignoreUndecoded === void 0 ? false : _ref4$ignoreUndecoded,
    onAfterFinish = _ref4.onAfterFinish,
    onBeforeStart = _ref4.onBeforeStart,
    onError = _ref4.onError,
    onMessage = _ref4.onMessage,
    onMessageError = _ref4.onMessageError,
    resendOptionsProp = _ref4.resendOptions;
  var stream = useOpts(streamDef);
  var resendOptions = useOpts(resendOptionsProp);
  var client = useClient();
  var onMessageRef = useRef(onMessage);
  useEffect(function () {
    onMessageRef.current = onMessage;
  }, [onMessage]);
  var onErrorRef = useRef(onError);
  useEffect(function () {
    onErrorRef.current = onError;
  }, [onError]);
  var onMessageErrorRef = useRef(onMessageError);
  useEffect(function () {
    onMessageErrorRef.current = onMessageError;
  }, [onMessageError]);
  var onBeforeStartRef = useRef(onBeforeStart);
  useEffect(function () {
    onBeforeStartRef.current = onBeforeStart;
  }, [onBeforeStart]);
  var onAfterFinishRef = useRef(onAfterFinish);
  useEffect(function () {
    onAfterFinishRef.current = onAfterFinish;
  }, [onAfterFinish]);
  useEffect(function () {
    var _onBeforeStartRef$cur2;
    if (disabled || !client) {
      return function () {};
    }
    (_onBeforeStartRef$cur2 = onBeforeStartRef.current) === null || _onBeforeStartRef$cur2 === void 0 ? void 0 : _onBeforeStartRef$cur2.call(onBeforeStartRef);
    var queue = subscribe(stream, client, {
      onError: function onError(e) {
        var _onErrorRef$current2;
        (_onErrorRef$current2 = onErrorRef.current) === null || _onErrorRef$current2 === void 0 ? void 0 : _onErrorRef$current2.call(onErrorRef, e);
      },
      onMessageError: function onMessageError(e) {
        var _onMessageErrorRef$cu2;
        (_onMessageErrorRef$cu2 = onMessageErrorRef.current) === null || _onMessageErrorRef$cu2 === void 0 ? void 0 : _onMessageErrorRef$cu2.call(onMessageErrorRef, e);
      },
      ignoreUndecodedMessages: ignoreUndecodedMessages,
      resendOptions: resendOptions
    });
    function fn(_x3) {
      return _fn3.apply(this, arguments);
    }
    function _fn3() {
      _fn3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(q) {
        var _onAfterFinishRef$cur2;
        var _yield$q$next2, value, done, _onMessageRef$current2;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!true) {
                _context9.next = 11;
                break;
              }
              _context9.next = 3;
              return q.next();
            case 3:
              _yield$q$next2 = _context9.sent;
              value = _yield$q$next2.value;
              done = _yield$q$next2.done;
              if (value) {
                (_onMessageRef$current2 = onMessageRef.current) === null || _onMessageRef$current2 === void 0 ? void 0 : _onMessageRef$current2.call(onMessageRef, value);
              }
              if (!done) {
                _context9.next = 9;
                break;
              }
              return _context9.abrupt("break", 11);
            case 9:
              _context9.next = 0;
              break;
            case 11:
              (_onAfterFinishRef$cur2 = onAfterFinishRef.current) === null || _onAfterFinishRef$cur2 === void 0 ? void 0 : _onAfterFinishRef$cur2.call(onAfterFinishRef);
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return _fn3.apply(this, arguments);
    }
    fn(queue);
    return function () {
      queue === null || queue === void 0 ? void 0 : queue.abort();
    };
  }, [disabled, stream, client, ignoreUndecodedMessages, resendOptions, cacheKey]);
}
function Provider(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded);
  var client = useClient(props);
  return /*#__PURE__*/jsx(ClientContext.Provider, {
    value: client,
    children: children
  });
}
export { ClientContext, Provider as default, resend, subscribe, useClient, useResend, useSubscribe };